import goodsApi from "@/api/goods.js";
export default {
    state: {
        goodList:[],
        good:{},
        shopList:[],
        shopDetail:{}
    },
    mutations: {
        updateList(state, data) {
            state.goodList = data;
        },
        shopList(state,data){
            state.shopList = data;
        },
        shopDetail(state,data){
            state.shopDetail = data;
        }


    },
    getters: {
        getGoodList(state) {
            return state.goodList;
        },
        getShopList(state){
            return state.shopList;
        },
        getShopDetail(state){
            return state.shopDetail;
        }
    },
    actions: {
        async goodList({ commit }) {
            await goodsApi.getGoods().then(function(response) {
                if(response.code == 200){
                    commit("updateList",response.data);
                }
            });
        },
        async shopList({ commit },data) {
            await goodsApi.getShopList(data).then(function(response) {
                if(response.code == 200){
                    commit("shopList",response.data);
                }
            });
        },
        async shopDetail({commit},pid){
            await goodsApi.getShopDetail(pid).then(function(response){
                if(response.code == 200){
                    commit("shopDetail",response.data);
                }
            })
        },
        async getArea({commit},pid){
            await goodsApi.getArea(pid).then(function(response){
                if(response.code == 200){
                    commit("shopDetail",response.data);
                }
            })
        }
    }
};
